<template>
    <div id="location-searcher" class="uk-position-relative">

    <div class="uk-position-relative">
      <span class="uk-form-icon" uk-icon="icon: nvsearch; ratio: 0.9;"></span>
      <input type="text" class="uk-input" id="location-search" v-model="inputValue" @input="searchLocation" placeholder="Søk etter" />
      <label class="uk-sr-only" for="location-search">Søk etter sted eller adresse</label>
    </div>
      <ul v-if="suggestions.length > 0" class="uk-list">
      <li v-for="suggestion in suggestions" :key="suggestion.magicKey">
        <a href="#" @click="selectSuggestion(suggestion)">{{ suggestion.text }}</a>
      </li>
    </ul>
    <!-- <p v-else-if="searchAttempted">No results found, try a different search.</p> -->

  </div>
</template>

<script setup lang="ts">
import { Ref,ref,inject } from 'vue';
import { LatLng } from 'leaflet';


interface Suggestion {
  text: string;
  magicKey: string;
  isCollection: boolean;
}

const inputValue = ref('');
const suggestions = ref<Suggestion[]>([]);
const searchAttempted = ref(false);

const mapCenter = inject('mapCenter') as Ref<LatLng | null>;

const setMapCenter = inject<(newCenter: LatLng) => void>('setMapCenter');

const searchLocation = () => {
  if (inputValue.value.length < 3) {
    suggestions.value = []
    return;
  }

  searchAttempted.value = true;  // Set to true as soon as a search is initiated

  const params = {
    f: 'json',
    text: inputValue.value,
    countryCode: 'NOR',
    token: import.meta.env.VITE_APP_ARCGIS_API_KEY,
    location: mapCenter.value ? `${mapCenter.value.lat},${mapCenter.value.lng}` : '',
    category: 'Address,City'
  }

  const queryString2 = new URLSearchParams(params).toString();

  fetch('https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?' + queryString2)
    .then(response => response.json())
    .then(data => {
      suggestions.value = data.suggestions;
      console.log(data.suggestions)
    })

}

const selectSuggestion = (suggestion: Suggestion) => {

  inputValue.value = suggestion.text
  suggestions.value = []

  const geocodeParams = {
    f: 'json',
    countryCode: 'NOR',
    token: import.meta.env.VITE_APP_ARCGIS_API_KEY,
    magicKey: suggestion.magicKey,
    singleLine: suggestion.text
  }

  const geocodeQueryString = new URLSearchParams(geocodeParams).toString();
  fetch('https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?' + geocodeQueryString)
    .then(response => response.json())
    .then(data => {
      // Ensure at least 1 candidate was returned
      if (data.candidates.length > 0) {
        // The first candidate would typically be the most relevant one
        const candidate = data.candidates[0];
        //mapCenter.value = new LatLng(candidate.location.y, candidate.location.x);
        if (setMapCenter) {
          setMapCenter(new LatLng(candidate.location.y, candidate.location.x));
        }
      }
    })
}
</script>
<style scoped>
.uk-input{
  width: 100%;
  background-color: #FAFAFA;
  color: #181818;
  font-size: 1rem;
  &::placeholder{
    color: #285960;
  }
  &:focus{
    background-color: #D6F19B;
  }
}
.uk-list{
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1;
  margin-top: 0;
  padding: 24px 16px;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  a{
    text-decoration: none;
    color: #181818;
  }
  a:hover,
  a:focus{
    text-decoration: underline;
    color: inherit;
  }
}
@media(min-width: 1024px){
  .uk-input{
    max-width: 416px;
  }
}
</style>